/**
 * DeleteDoneCard · 删除/恢复完成反馈卡。
 *
 * 由前端在 deleteFolder / restoreFolder 调用成功后**本地构造**助手消息塞入这个
 * 卡片，不再请求 LLM；让用户感知"操作已落"。
 *
 * 当前 DeleteConfirmCard 完成时是直接把卡片本身切到 done 视觉态（同卡内反馈），
 * 没用 DeleteDoneCard；DeleteDoneCard 主要给"回收站抽屉里恢复"场景用 — 恢复后
 * 在对话流里追加一条说明，告诉用户"已恢复 X，可在文件夹列表查看"。
 */

import { DeleteFilled, FolderOutlined, RedoOutlined } from '@ant-design/icons'
import React from 'react'
import type { DeleteDoneCard as DeleteDoneCardType } from '../../../../../../../types/ai-classify'
import styles from './card.module.scss'

interface Props {
  card: DeleteDoneCardType
}

const DeleteDoneCard: React.FC<Props> = ({ card }) => {
  const isRestore = card.operationType === 'restore'
  return (
    <div className={styles.card}>
      <div className={styles.creationSummary}>
        {isRestore ? (
          <RedoOutlined
            style={{
              color: isRestore ? '#10b981' : '#ef4444',
              marginRight: 6,
              fontSize: 14
            }}
          />
        ) : (
          <DeleteFilled
            style={{
              color: isRestore ? '#10b981' : '#ef4444',
              marginRight: 6,
              fontSize: 14
            }}
          />
        )}
        {card.summary}
      </div>
      {card.folders.length > 0 && (
        <ul className={styles.creationList}>
          {card.folders.map((f) => (
            <li key={f.folder_id} className={styles.creationItem}>
              <FolderOutlined style={{ marginRight: 6, color: '#3b82f6' }} />
              <span className={styles.creationName}>{f.folder_name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default DeleteDoneCard
